import { render, staticRenderFns } from "./MoveWarehouseItemModal.vue?vue&type=template&id=8c473106"
import script from "./MoveWarehouseItemModal.vue?vue&type=script&lang=js"
export * from "./MoveWarehouseItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports